import React, { useCallback } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import _isEmpty from "lodash/isEmpty";
import { getTournamentCurrentStatus } from "../../utils/helpers/TournamentNXUtils";
import { ReactComponent as LiveIcon } from "../../assets/live-icon.svg";
import { ReactComponent as NotLiveIcon } from "../../assets/not-live-icon.svg";
import {
  TournamentStatus,
  WidgetItem,
} from "../../interfaces/TournamentsConfig";
import {
  COLOR_1DAE34,
  COLOR_BLACK_959595,
  COLOR_PURPLE,
} from "../../assets/colors";
import { formatTimestampTo } from "../../utils/DateUtils";
import { getResultOutTimeFormat } from "../../utils/helpers/common";
import { useTranslation } from "react-i18next";

interface StatusStripInterface {
  tournament: WidgetItem;
}

interface IStatusBarUI {
  statusBarcolor: string;
  resultStatusText?: string;
  tournamentStatusText?: string;
  live?: boolean;
}

const StatusStrip: React.FC<StatusStripInterface> = ({ tournament }) => {
  const { t } = useTranslation();
  const tournamentStatus = getTournamentCurrentStatus(tournament);

  const getStatusBarUI = useCallback(() => {
    let newStatusBarUI = {};
    // const tournament = getNXTournamentInfo()
    if (tournament?.isSuspended) {
      newStatusBarUI = {
        statusBarcolor: COLOR_BLACK_959595,
        resultStatusText: "", //left text
        tournamentStatusText: t("tournamentCancelled"), //right text
        live: false,
      };
    } else {
      switch (tournamentStatus) {
        case TournamentStatus.TOURNAMENT_NOT_STARTED:
          newStatusBarUI = {
            statusBarcolor: COLOR_PURPLE,
            resultStatusText: _isEmpty(tournament?.tournamentStartTimeText)
              ? t("tournamentStartsAt", {
                  time: formatTimestampTo(
                    tournament?.registrationStartTime,
                    getResultOutTimeFormat(tournament?.registrationStartTime)
                  ),
                })
              : tournament.tournamentStartTimeText,
            tournamentStatusText: "",
            live: false,
          };
          break;
        case TournamentStatus.TOURNAMENT_LIVE_USER_NOT_ENTERED:
          newStatusBarUI = {
            statusBarcolor: COLOR_1DAE34,
            resultStatusText: "",
            tournamentStatusText: t("liveTournament"),
            live: true,
          };
          break;
        case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_REMAINING:
        case TournamentStatus.TOURNAMENT_LIVE_USER_ENTERED_ENTRY_NOT_REMAINING:
          newStatusBarUI = {
            statusBarcolor: COLOR_1DAE34,
            resultStatusText: _isEmpty(tournament?.tournamentResultOutTimeText)
              ? t("finalResultOutAt", {
                  time: formatTimestampTo(
                    tournament?.resultDeclareTime,
                    getResultOutTimeFormat(tournament?.resultDeclareTime)
                  ),
                })
              : tournament.tournamentResultOutTimeText,
            tournamentStatusText: t("liveTournament"),
            live: true,
          };
          break;
        case TournamentStatus.TOURNAMENT_CLOSED_RESULT_PENDING:
          newStatusBarUI = {
            statusBarcolor: COLOR_PURPLE,
            resultStatusText: _isEmpty(tournament?.tournamentResultOutTimeText)
              ? t("finalResultOutAt", {
                  time: formatTimestampTo(
                    tournament?.resultDeclareTime,
                    getResultOutTimeFormat(tournament?.resultDeclareTime)
                  ),
                })
              : tournament.tournamentResultOutTimeText,
            tournamentStatusText: t("tournamentClosed"),
            live: false,
          };
          break;
        case TournamentStatus.TOURNAMENT_CLOSED_RESULT_OUT:
          newStatusBarUI = {
            statusBarcolor: COLOR_PURPLE,
            resultStatusText: t("finalResultOutNow"),
            tournamentStatusText: t("tournamentClosed"),
            live: false,
          };
          break;
        case TournamentStatus.TOURNAMENT_CLOSED_DISPLAY_ENDED:
          newStatusBarUI = {
            statusBarcolor: COLOR_BLACK_959595,
            resultStatusText: "",
            tournamentStatusText: t("tournamentClosed"),
            live: false,
          };
          break;
        default:
          break;
      }
    }
    return newStatusBarUI as IStatusBarUI;
  }, [
    t,
    tournament?.isSuspended,
    tournament?.registrationStartTime,
    tournament?.resultDeclareTime,
    tournament.tournamentResultOutTimeText,
    tournament.tournamentStartTimeText,
    tournamentStatus,
  ]);

  const statusBarUI = getStatusBarUI();


  if (_isEmpty(tournamentStatus) || _isEmpty(statusBarUI)) {
    return null;
  }

  return (
    <div
      className={clsx(
        styles.statusStipContainer,
        "textUppercase fontSizeXs fontWeightMedium fontColorWhite"
      )}
      style={{ backgroundColor: statusBarUI?.statusBarcolor }}
    >
      {!_isEmpty(statusBarUI?.resultStatusText) && (
        <>
          {statusBarUI?.resultStatusText}
          {!statusBarUI?.live && <NotLiveIcon />}
        </>
      )}
      {statusBarUI?.live && <LiveIcon className={clsx(styles.liveIcon)} />}
      {!_isEmpty(statusBarUI?.tournamentStatusText) &&
        statusBarUI?.tournamentStatusText}
    </div>
  );
};

export default StatusStrip;
